import { useMemo } from "react";
import { useModalContext } from "common/contexts";
import useCurrentUser from "hooks/useCurrentUser";
import usePermissions from "hooks/usePermissions";
import { useGetUsersNTeams } from "security-app/hooks/useSecurityEventsAPI";
import { adminAssignee } from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerTitles";
const useOwnerAction = (securityEvent) => {
  const { setModal, setEntity } = useModalContext();
  const { usersNTeams } = useGetUsersNTeams();
  const currentUser = useCurrentUser();
  const { isPermitted } = usePermissions();
  const currentOwnerName = useMemo(() => {
    if (!securityEvent.owner) return void 0;
    const admin = adminAssignee(securityEvent.owner);
    if (admin) return admin.label;
    const match = usersNTeams.find((entry) => entry.id === securityEvent.owner);
    if (match) return match.name;
    if (securityEvent.owner === currentUser.id) return currentUser.fullName;
    if (isPermitted("users:list")) return `${securityEvent.owner} (deleted)`;
    return "Assigned";
  }, [securityEvent.owner, usersNTeams, currentUser.id, currentUser.fullName, isPermitted]);
  const selectOwner = () => {
    setEntity(securityEvent);
    setModal("SELECT-OWNER");
  };
  const onRemoveOwner = () => {
    setEntity(securityEvent);
    setModal("CONFIRM-OWNER-REMOVE");
  };
  return {
    selectOwner,
    onRemoveOwner,
    currentOwnerName
  };
};
export default useOwnerAction;
